import { useHistory } from 'react-router-dom';
import AssessmentFlowComponent from 'components/assessment-flow';
import { ANXIETY_ASSESSMENT_QUESTIONS } from 'components/shared/analytics/segment-events';
import { ANXIETY } from 'components/shared/types';
import { IQuestion } from 'components/assessment-flow/types';
import {
  ANXIETY_ASSESSMENT_RESULT,
  ANXIETY_ASSESSMENT_SCORING
} from 'constants/localStorageKey';

export const AnxietyAssessment = () => {
  const history = useHistory();

  const handleNextPage = () => {
    const data = localStorage.getItem(ANXIETY_ASSESSMENT_RESULT) || '';
    const assessmentResult = JSON.parse(data) as IQuestion[];
    const score = assessmentResult.reduce(
      (result, question) => result + (question.selectedOption?.score || 0),
      0
    );

    localStorage.setItem(ANXIETY_ASSESSMENT_SCORING, score.toString());
    history.push('/anxiety-assessment-email');
  };

  return (
    <AssessmentFlowComponent
      serviceLine={ANXIETY}
      handleNextPage={handleNextPage}
      segmentEventName={ANXIETY_ASSESSMENT_QUESTIONS}
      storageKey={ANXIETY_ASSESSMENT_RESULT}
    />
  );
};

export default AnxietyAssessment;
